import { render, staticRenderFns } from "./acknowledgementNew.vue?vue&type=template&id=aff1ea0e"
import script from "./acknowledgementNew.vue?vue&type=script&lang=js"
export * from "./acknowledgementNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports